export default "__VITE_ASSET__CaDGGF$d__"